(() => {
  const setLoadingState = (button, form) => {
    if (!button || button.disabled) return

    button.disabled = true
    button.classList.add('is-loading')
    button.setAttribute('aria-disabled', 'true')

    if (form) {
      form.setAttribute('aria-busy', 'true')
    }
  }

  const focusStatus = (root) => {
    const status = root.querySelector('.mt-contact-form__status')
    if (!status) return

    requestAnimationFrame(() => {
      try {
        status.focus({ preventScroll: true })
      } catch (e) {
        status.focus()
      }
      status.scrollIntoView({ block: 'start' })
    })
  }

  const defineLoaderButton = () => {
    if (!window.customElements) return
    if (customElements.get('loader-button')) return

    try {
      class LoaderButton extends HTMLButtonElement {
        connectedCallback() {
          if (this.__mtInitialized) return
          this.__mtInitialized = true

          const form = this.form || this.closest('form')
          if (!form) return

          form.addEventListener('submit', () => {
            if (typeof form.checkValidity === 'function' && !form.checkValidity()) return
            setLoadingState(this, form)
          })
        }
      }

      customElements.define('loader-button', LoaderButton, { extends: 'button' })
    } catch (e) {}
  }

  const initSection = (root) => {
    const form = root.querySelector('.mt-contact-form__form')
    if (!form) return

    const submitButton = form.querySelector('.mt-contact-form__submit')
    if (submitButton) {
      form.addEventListener('submit', () => {
        if (typeof form.checkValidity === 'function' && !form.checkValidity()) return
        setLoadingState(submitButton, form)
      })
    }

    focusStatus(root)
  }

  document.addEventListener('DOMContentLoaded', () => {
    defineLoaderButton()
    document.querySelectorAll('.mt-contact-form[data-section-id]').forEach(initSection)
  })
})()
